import * as actionTypes from "../actionTypes";

export const savePerson = function (isNewClient, person) {
  return { type: actionTypes.SAVE_PERSON, payload: { isNewClient, person } };
};
